export default "__VITE_ASSET__Cnda7JXO__"